"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./index.less");
const react_1 = require("react");
const StyledFooter_1 = require("../../../material-ui-theme/components/styled/StyledFooter");
const zustandStore_1 = require("../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../atoms/button/simpleButton"));
const Footer = props => {
    const buttons = (0, zustandStore_1.useZustand)(state => state.footer.buttons);
    const memoizedButtons = (0, react_1.useMemo)(() => buttons, [buttons]);
    return ((0, jsx_runtime_1.jsxs)(StyledFooter_1.StyledFooter, { "data-testid": "footer", children: [props.children, memoizedButtons.map(button => ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: button.dataTestId, label: button.label, disabled: button.disabled || false, onClick: button.onclick, color: button.color, style: { margin: 2 } }, button.label)))] }));
};
exports.default = Footer;
